var map = {
	"./template.betgalaxy": 2131,
	"./template.betgalaxy.tsx": 2131,
	"./template.betprofessor": 2018,
	"./template.betprofessor.tsx": 2018,
	"./template.betroyale": 2019,
	"./template.betroyale.tsx": 2019,
	"./template.default": 710,
	"./template.default.tsx": 710,
	"./template.fiestabet": 1958,
	"./template.fiestabet.tsx": 1958,
	"./template.forsport": 1959,
	"./template.forsport.tsx": 1959,
	"./template.goldenrush": 2020,
	"./template.goldenrush.tsx": 2020,
	"./template.juicybet": 2021,
	"./template.juicybet.tsx": 2021,
	"./template.junglebet": 2022,
	"./template.junglebet.tsx": 2022,
	"./template.oldgill": 2023,
	"./template.oldgill.tsx": 2023,
	"./template.puntcity": 2024,
	"./template.puntcity.tsx": 2024,
	"./template.puntgenie": 1987,
	"./template.puntgenie.tsx": 1987,
	"./template.questbet": 2025,
	"./template.questbet.tsx": 2025,
	"./template.sterlingparker": 2026,
	"./template.sterlingparker.tsx": 2026,
	"./template.sugarcastle": 2027,
	"./template.sugarcastle.tsx": 2027,
	"./template.ts": 1002,
	"./template.vikingbet": 2132,
	"./template.vikingbet.tsx": 2132,
	"./template.volcanobet": 1992,
	"./template.volcanobet.tsx": 1992,
	"./template.wellbet": 2028,
	"./template.wellbet.tsx": 2028
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2808;